import React from "react";

import "./socialMediaLink.css";

import FacebookIcon from "../../assets/icons/socialMedia/facebookIcon";
import InstagramIcon from "../../assets/icons/socialMedia/instagramIcon";
import YoutubeIcon from "../../assets/icons/socialMedia/youtubeIcon";
import SoundcloudIcon from "../../assets/icons/socialMedia/soundcloudIcon";
import WebsiteIcon from "../../assets/icons/socialMedia/websiteIcon";
import SpotifyIcon from "../../assets/icons/socialMedia/spotifyIcon";
import { checkUrlAndAddHttp, isValidUrl } from "../../utils/urlUtils";

interface SocialMediaLinkProps {
    network: string;
    link: string;
}

export default function SocialMediaLink(props: SocialMediaLinkProps) {
    return <div className="social-media-link">
        {getSocialMediaIcon(props.network)}
        <a onClick={() => {
            if (props.network === "website") {
                if(isValidUrl(checkUrlAndAddHttp(props.link))) {
                    window.open(checkUrlAndAddHttp(props.link), "_blank");
                }
            } else {
                window.open("https://" + props.network + ".com/" + props.link, "_blank");
            }
        }}>{props.link}</a>
    </div>;
}

function getSocialMediaIcon(network: string) {
    switch (network) {
        case "facebook":
            return <FacebookIcon/>;
        case "instagram":
            return <InstagramIcon/>;
        case "youtube":
            return <YoutubeIcon/>;
        case "soundcloud":
            return <SoundcloudIcon/>;
        case "spotify":
            return <SpotifyIcon/>;
        default:
            return <WebsiteIcon/>;
    }
}


export {getSocialMediaIcon}